import { createContext, type Dispatch } from 'react';

import { type Action, type SessionState } from './types';

export const SessionStateContext = createContext<SessionState | null>(null);
export const SessionDispatchContext = createContext<Dispatch<Action> | null>(null);
